import React from 'react'
import ViewDownload from '../../../elements/ViewDownload'
import {streamUrl} from '../../../variables/index'
import Authentication from '../../../modules/Authentication'

const auth = new Authentication()
const FileCell = ({value}) =>
  value && (
    <ViewDownload
      view={`${streamUrl}files/${value}?action=view&access_token=${auth.getAccessToken()}`}
      download={`${streamUrl}files/${value}?action=download&access_token=${auth.getAccessToken()}`}
    />
  )
export default FileCell
